import axios from 'axios';
import { NoteModel, NoteCreateModel } from '@/types';

const NoteApiUrl = 'notes';

export const NoteService = {
  async getNotesAsync(entityTypeId: number, entityPk: string, cabinetId: string = ''): Promise<NoteModel[]> {
    const response = await axios.get(NoteApiUrl.concat('/', entityTypeId.toString(), '/', entityPk, '/', cabinetId));
    return response.data;
  },
  async createNoteAsync(entityTypeId: number, entityPk: string, noteCreateModel: NoteCreateModel, cabinetId: string = ''): Promise<number> {
    const response = await axios.post(NoteApiUrl.concat('/', entityTypeId.toString(), '/', entityPk, '/', cabinetId), noteCreateModel);
    return response.data;
  },

  async updateNoteAsync(entityTypeId: number, entityPk: string, noteUpdateModel: NoteModel, cabinetId: string = '') {
    const response = await axios.put(NoteApiUrl.concat('/', entityTypeId.toString(), '/', entityPk, '/', cabinetId), noteUpdateModel);
    return response.data;
  },

  async deleteNoteAsync(entityTypeId: number, entityPk: string, noteId: number, cabinetId: string = '') {
    const response = await axios.delete(`${NoteApiUrl}/${entityTypeId}/${entityPk}/${noteId}/${cabinetId}`);
    return response.data;
  }
};
